import {get, post, put, _delete} from './Tools';

const getLeyByAntiguedad = async (antiguedad) => {
  const response = await get(`${process.env.REACT_APP_SERVER}integracion_detalle/get/ley/${antiguedad}`);
  return response;
};

const getAll = async (integrationId) => {
  const response = await get(`${process.env.REACT_APP_SERVER}integracion_detalle/filter/${integrationId}`);
  return response;
};



const getList = async (integrationId) => {
  const response = await get(`${process.env.REACT_APP_SERVER}integracion_detalle/get/list/${integrationId}`);
  return response;
};

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}integracion_detalle/${id}`);
  return response;
};

const insert = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}integracion_detalle`, payload);
  return response;
};

const update = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}integracion_detalle`, payload);
  return response;
};

const drop = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}integracion_detalle/${id}`);
  return response;
};

const calculateFactorIntegracion = async (dias_aguinaldo, dias_vacaciones, prima_vacacional) => {
  const response = await get(`${process.env.REACT_APP_SERVER}integracion_detalle/calculate?dias_aguinaldo=${dias_aguinaldo}&dias_vacaciones=${dias_vacaciones}&prima_vacacional=${prima_vacacional}`);
  return response;
}

export { getLeyByAntiguedad, getAll, getList, getById, insert, update, drop, calculateFactorIntegracion };